import styled from 'styled-components';
import bg from '../../assets/images/maze-bacground.svg';

export const Container = styled.div`
    display: flex;
    width: 100vw;
    height: 90vh;
    align-items: center;
    justify-content: center;
    background-image: url(${bg});
    background-color: #000;
    background-size: cover;
`

export const ResetForm = styled.form`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    background-color: #1a1a1a;
    width: 500px;
    height: 400px;
    border-radius: 5px;
    padding: 1em 2em;
    color: #fff;

    h1.reset-pass, h1.reset-success {
        font: italic bold 28px 'Roboto Condensed';
        text-transform: uppercase;
        text-align: center;
    }
    p.reset-instruction {
        text-align: center;
    }
    h1.invalid-link {
        text-align: center;
        color: #ff0033;
        font-size: 24px;
    }

    div.success-icon, div.fail-icon {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        background-color: #555;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .reset-fail {color: #ff0033;}
    .reset-pass {color: #acff24;}
    
`


// WEBPACK FOOTER //
// ./src/pages/ResetPassword/ResetPassword.styles.ts